var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70.36 39.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#ccc;stroke-miterlimit:10;}.cls-2{fill-rule:evenodd;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -750.11,
    y1: 276.18,
    x2: -749.67,
    y2: 276.18,
    gradientTransform: "matrix(101, 0, 0, -32.89, 75774.17, 9101.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26235d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d50a0"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 69.36,
    height: 38.19,
    rx: 2.83
  }), /*#__PURE__*/React.createElement("g", {
    id: "Creditcards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35,12.68,32,26.55H28.47l2.94-13.87Zm15,9,1.88-5.2,1.07,5.2Zm4,4.92h3.29L54.32,12.68h-3a1.62,1.62,0,0,0-1.51,1L44.43,26.55h3.74l.74-2.08h4.56ZM44.62,22c0-3.66-5-3.86-5-5.5,0-.49.48-1,1.51-1.16a6.63,6.63,0,0,1,3.51.62L45.27,13A9.5,9.5,0,0,0,42,12.43c-3.52,0-6,1.88-6,4.58,0,2,1.76,3.11,3.11,3.77s1.85,1.12,1.84,1.73c0,.93-1.1,1.34-2.12,1.35A7.4,7.4,0,0,1,35.11,23l-.64,3a10.64,10.64,0,0,0,4,.73c3.74,0,6.19-1.86,6.2-4.74ZM29.88,12.68,24.12,26.55H20.36L17.52,15.48a1.53,1.53,0,0,0-.84-1.22,15.18,15.18,0,0,0-3.51-1.18l.08-.4h6.06A1.67,1.67,0,0,1,21,14.09l1.49,8,3.71-9.44Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4640f3c7ddf43ad1ab156f6a2509d3d7.svg";
export { ForwardRef as ReactComponent };